<template>
  <span><slot v-bind="item">{{ item ? item.name : '' }}</slot></span>
</template>

<script>
export default {
  name:    "DictionaryItem",
  props:   ['dictionary', 'id', 'renderValue'],
  data() {
    return {
      item: null,
    };
  },
  methods: {
    loadItem() {
      const { dictionary, id } = this;
      if (id === null || id === undefined || !dictionary) return this.item = null;
      dictionary.getById(id).then(item => {
        this.item = item;
      });
    },
  },
  mounted() {
    this.loadItem();
  },
  watch:   {
    id() {
      this.loadItem();
    },
    dictionary() {
      this.loadItem();
    },
  },
};
</script>

<style scoped>

</style>
